var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailClickedinline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#4caf51;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H17V17H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.251 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M346.738-174.9l-7.637-6.249a.347.347,0,0,0-.488.052.348.348,0,0,0-.077.215v10.415a.347.347,0,0,0,.347.347.347.347,0,0,0,.289-.155l2.675-4.011h4.674a.347.347,0,0,0,.347-.347.347.347,0,0,0-.128-.269Z",
    transform: "translate(-332.473 186.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M343.281-184.927a6.366,6.366,0,0,0-3.554-3.377,6.413,6.413,0,0,0-8.279,3.679,6.414,6.414,0,0,0,3.684,8.281.849.849,0,0,0,.3.054l.415,0,.023-.121a.85.85,0,0,0,.361-.428.852.852,0,0,0-.494-1.1,4.709,4.709,0,0,1-2.7-6.08,4.708,4.708,0,0,1,6.081-2.7,4.723,4.723,0,0,1,2.68,6.127.854.854,0,0,0,.437.987.847.847,0,0,0,.65.049.866.866,0,0,0,.515-.471A6.365,6.365,0,0,0,343.281-184.927Z",
    transform: "translate(-331.021 188.731)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailClickedinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-clicked.inline.df522235c384d71614e3cc0005b7408f.svg";